import { Injectable } from "@angular/core"
import domtoimage from 'dom-to-image'

@Injectable({
  providedIn: 'root'
})
export class ImageService {

    constructor() { }

    renderImage(element: HTMLElement, name: string) {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
          return
        }
        
        const exportWidth = 1080
        const exportHeight = 1350

        const rect = element.getBoundingClientRect()
        const scaleX = exportWidth / rect.width
        const scaleY = exportHeight / rect.height
        const scale = Math.min(scaleX, scaleY)

        const style = {
            transform: `scale(${scale})`,
            transformOrigin: 'top left',
            width: rect.width + 'px',
            height: rect.height + 'px'
        }

        domtoimage.toPng(element, {
            width: exportWidth,
            height: exportHeight,
            style
        })
        .then(url => {
            const a = document.createElement('a')
            a.href = url
            a.download = name
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        })
        .catch(error => {
            console.error('Error al generar imagen:', error)
        })
    }


    convertImage(element: HTMLElement, name: string){
        if (typeof window === 'undefined' || typeof document === 'undefined') {
          return
        }

        const clonedElement = element.cloneNode(true) as HTMLElement
    
        const exportWidth = 1080
        const exportHeight = 1350

        const originalRect = element.getBoundingClientRect()
        const scaleX = exportWidth / originalRect.width
        const scaleY = exportHeight / originalRect.height
        const scale = Math.min(scaleX, scaleY)

        clonedElement.style.width = originalRect.width + 'px'
        clonedElement.style.height = originalRect.height + 'px'
        clonedElement.style.position = 'absolute'
        clonedElement.style.top = '0'
        clonedElement.style.left = '0'
        clonedElement.style.zIndex = '-9999'
        clonedElement.style.background = 'white'
        clonedElement.style.overflow = 'hidden'

        const innerWrapper = document.createElement('div')
        innerWrapper.style.width = exportWidth + 'px'
        innerWrapper.style.height = exportHeight + 'px'
        innerWrapper.style.overflow = 'hidden'
        innerWrapper.style.transformOrigin = 'top left'
        innerWrapper.style.transform = `scale(${scale})`

        innerWrapper.appendChild(clonedElement)
        document.body.appendChild(innerWrapper)

        const computed = window.getComputedStyle(element)
        for (const prop of Array.from(computed)) {
            clonedElement.style.setProperty(prop, computed.getPropertyValue(prop))
        }

        this.copyComputedStyles(element, clonedElement)

        const images = Array.from(clonedElement.querySelectorAll('img'))
        Promise.all(
        images.map(img =>
            img.complete ? Promise.resolve() : new Promise(resolve => (img.onload = resolve))
        )
        ).then(() => {
        domtoimage.toPng(innerWrapper, {
            width: exportWidth,
            height: exportHeight
        })
        .then(url => {
            const a = document.createElement('a')
            a.href = url
            a.download = name
            document.body.appendChild(a)
            a.click()
            window.URL.revokeObjectURL(url)
            document.body.removeChild(a)
            document.body.removeChild(innerWrapper)
        })
        .catch(error => {
            document.body.removeChild(innerWrapper)
            console.error('Oops, something went wrong!', error)
        })
        })
    }
    
    copyComputedStyles(original: HTMLElement, clone: HTMLElement) {
        const originalChildren = original.querySelectorAll('*')
        const cloneChildren = clone.querySelectorAll('*')

        originalChildren.forEach((origEl, index) => {
            const cloneEl = cloneChildren[index] as HTMLElement
            if (cloneEl) {
                const computed = window.getComputedStyle(origEl)
                for (const prop of Array.from(computed)) {
                    cloneEl.style.setProperty(prop, computed.getPropertyValue(prop))
                }
            }
        })
    }
}
